module.exports = __webpack_public_path__ + "img/zfyggbm.eca4ffec.png";